import React from 'react'

import {Container,TextWrapper,NameWrapper,ImgWrapper} from "./style"

const  FeedbackCard=({value}) => {
  console.log(value);
  return (
    <Container>
     <TextWrapper>
      {value.title}
     </TextWrapper>
     <NameWrapper>
      {value.name}
     </NameWrapper>
     <ImgWrapper src={value.img}/>
    </Container>
  )
}

export default FeedbackCard
